import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';

const PreRegisteredDatas = ({ preRegisteredDoc }) => {
  const intl = useIntl();
  const keys = {
    other: [
      'docket_number',
      'arriving_date',
      'arriving_time',
      'start_discharging_time',
      'finish_discharging_time',
      'mash_control',
      'mash_control_extra',
      'specimens_number',
      'slump',
      'detailed_location',
      'elements',
    ],
    cemex: [
      'docket_number',
      'arriving_date',
      'manufacture_time',
      'arriving_time',
      'start_discharging_time',
      'finish_discharging_time',
      'recipe',
      'mash_control',
      'mash_control_extra',
      'slump',
      'specimens_number',
      'detailed_location',
      'plant',
      'delivered',
      'elements',
    ],
  };

  return (
    <div className="row row-project" style={{ margin: '0 10px 0 10px' }}>
      <div className="col-xs-12 col-sm-12 col-md-12">
        {keys[preRegisteredDoc.model].map((key) => (
          <div style={{ fontSize: '17px', marginBottom: '1em' }} key={key}>
            <span style={{ fontWeight: 'bold', marginRight: '10px' }}>
              {intl.formatMessage({ id: key })}:
            </span>
            {(() => {
              switch (key) {
                case 'arriving_date': {
                  return preRegisteredDoc[key];
                }
                case 'mash_control':
                case 'mash_control_extra':
                  return preRegisteredDoc[key] === false
                    ? intl.formatMessage({ id: 'no' })
                    : intl.formatMessage({ id: 'yes' });
                case 'specimens_number':
                case 'slump':
                  return !preRegisteredDoc[key] ? 'N/A' : preRegisteredDoc[key];
                case 'model':
                  return intl.formatMessage({ id: preRegisteredDoc[key] });
                case 'elements':
                  if (
                    preRegisteredDoc[key] === null ||
                    preRegisteredDoc[key].length === 0
                  ) {
                    return intl.formatMessage({ id: 'notElements' });
                  } else {
                    const elementsArray = preRegisteredDoc[key].split(',');
                    return elementsArray ? (
                      <ul>
                        {elementsArray?.map((element, index) => (
                          <li key={index}>{`- ${intl.formatMessage({
                            id: element,
                          })}`}</li>
                        ))}
                      </ul>
                    ) : null;
                  }
                default:
                  return preRegisteredDoc[key];
              }
            })()}
          </div>
        ))}
      </div>
    </div>
  );
};

PreRegisteredDatas.propTypes = {
  preRegisteredDoc: PropTypes.shape({
    model: PropTypes.string,
  }),
};

PreRegisteredDatas.defaultProps = {
  preRegisteredDoc: undefined,
};
export default PreRegisteredDatas;
